import { ApiEndpoints } from "../endpoints";
import { makeQuery } from "../api";
import { ProfileSchema } from "../../model/profile/schema";

export default async function getProfile(id: number) {
  try {
    const response = await makeQuery(ApiEndpoints.profile(id), false);
    return ProfileSchema.parse(response.data);
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
